/**
 * Get error response code from the response message
 */
export default function getErrorResponseCode(responseMessage) {
    if (responseMessage && responseMessage.ResponseClass != 'Success') {
        return [responseMessage.ResponseCode, responseMessage.StackTrace];
    }
    else {
        return [null, null];
    }
}
//# sourceMappingURL=getErrorResponseCode.js.map